import { render, staticRenderFns } from "./Part-Date.vue?vue&type=template&id=587c70b2"
import script from "./Part-Date.vue?vue&type=script&setup=true&lang=js"
export * from "./Part-Date.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports